export const TwoThousand = 2000;
export const Thousand = 1000;
export const TwentyFour = 24;
export const Sixty = 60;
export const NumberTen = 10;
export const NumberEight = 8;
export const NumberSix = 6;
export const NumberFive = 5;
export const NumberFour = 4;
export const NumberThree = 3;
export const NumberTwo = 2;
export const otherDiscounts = 'n'; //y for mandatory to show ,n for non-mandatory(will show if >0)
export const saleTax = 'n'; //used in std flow and order detail currntly - y for mandatory to show ,n for non-mandatory(will show if >0)